/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * 验证是否为外部链接
 * @param {string} path - 要验证的路径
 * @returns {Boolean} - 验证结果
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 验证密码格式
 * @param {string} value - 要验证的密码
 * @returns {Boolean} - 验证结果
 */
export function password(value) {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/.test(value);
}

/**
 * 增强版密码验证
 * @param {string} value - 要验证的密码
 * @returns {Object} - 包含验证结果和错误信息的对象
 */
export function validatePassword(value) {
  if (!value) {
    return {
      valid: false,
      message: '密码不能为空'
    }
  }
  if (value.length < 6 || value.length > 12) {
    return {
      valid: false,
      message: '密码长度必须在6-12个字符之间'
    }
  }
  if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/.test(value)) {
    return {
      valid: false,
      message: '密码必须包含数字和字母，不能是纯数字或纯字母'
    }
  }
  return {
    valid: true,
    message: '密码格式正确'
  }
}

/**
 * 验证邮箱格式
 * @param {string} value - 要验证的邮箱
 * @returns {Boolean} - 验证结果
 */
export function email(value) {
  return /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/.test(value);
}

/**
 * 验证手机号格式
 * @param {string} value - 要验证的手机号
 * @returns {Boolean} - 验证结果
 */
export function phone(value) {
  return /^1[3-9]\d{9}$/.test(value);
}

/**
 * 增强版手机号验证
 * @param {string} value - 要验证的手机号
 * @returns {Object} - 包含验证结果和错误信息的对象
 */
export function validatePhone(value) {
  if (!value) {
    return {
      valid: false,
      message: '手机号不能为空'
    }
  }
  if (!/^1[3-9]\d{9}$/.test(value)) {
    return {
      valid: false,
      message: '请输入正确的手机号格式'
    }
  }
  return {
    valid: true,
    message: '手机号格式正确'
  }
}

/**
 * Element UI表单验证规则：手机号
 * @returns {Array} - Element UI表单验证规则数组
 */
export function phoneRules() {
  return [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { validator: (rule, value, callback) => {
        const result = validatePhone(value);
        if (result.valid) {
          callback();
        } else {
          callback(new Error(result.message));
        }
      }, trigger: 'blur' }
  ]
}

/**
 * Element UI表单验证规则：密码
 * @returns {Array} - Element UI表单验证规则数组
 */
export function passwordRules() {
  return [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { validator: (rule, value, callback) => {
        const result = validatePassword(value);
        if (result.valid) {
          callback();
        } else {
          callback(new Error(result.message));
        }
      }, trigger: 'blur' }
  ]
}